export default {"src":"/_next/static/media/mana1.b1642f88.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};